import { createContext } from 'react';

/**
 * Interface representing the context for a translation namespace.
 */

/**
 * Default values for the `TranslationsNamespaceContext`.
 */
const defaultValues = {
  namespace: ''
};

/**
 * Context for managing the current translation namespace.
 */
export const translationsNamespaceContext = /*#__PURE__*/createContext(defaultValues);
//# sourceMappingURL=translationsNamespaceContext.js.map